import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-col-3",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/layout/images/login/icon-login.svg",
    alt: "avalon-vue"
  })
], -1)
const _hoisted_8 = {
  class: "p-col-9",
  style: {"text-align":"left"}
}
const _hoisted_9 = { class: "welcome-text" }
const _hoisted_10 = { class: "guest-sign-in" }
const _hoisted_11 = {
  key: 0,
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = {
  key: 1,
  class: "p-col-12",
  style: {"text-align":"left"}
}
const _hoisted_15 = { class: "login_label" }
const _hoisted_16 = { class: "login_input" }
const _hoisted_17 = {
  key: 2,
  class: "p-col-12 login_form__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_VField = _resolveComponent("VField")!
  const _component_VI18nError = _resolveComponent("VI18nError")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VForm = _resolveComponent("VForm")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("img", {
          alt: "Logo",
          src: '/assets/layout/images/' + _ctx.logo,
          width: "400"
        }, null, 8, _hoisted_5)
      ]),
      _createVNode(_component_VForm, {
        onSubmit: _ctx.sendEmail,
        as: "form"
      }, {
        default: _withCtx(({ isSubmitting, meta: { valid } }) => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("h2", _hoisted_9, null, 512), [
                [_directive_t, 'lost_password.title']
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_10, null, 512), [
                [_directive_t, 'lost_password.subtitle']
              ])
            ]),
            (_ctx.emailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_Message, {
                    severity: "success",
                    closable: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('lost_password.email_sent_message')), 1),
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('lost_password.check_inbox_to_continue')), 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.emailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("label", _hoisted_15, null, 512), [
                    [_directive_t, 'lost_password.email']
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_VField, {
                      name: "email",
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event)),
                      rules: "required"
                    }, {
                      default: _withCtx(({ field, meta: {dirty, valid} }) => [
                        _createVNode(_component_InputText, _mergeProps({ autofocus: "" }, field, {
                          disabled: isSubmitting,
                          class: {'p-invalid': dirty && !valid},
                          placeholder: "Email"
                        }), null, 16, ["disabled", "class"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue"]),
                    _createVNode(_component_VI18nError, { name: "email" })
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.emailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_Button, {
                    label: _ctx.$t('lost_password.send_email'),
                    type: "submit",
                    disabled: !valid || isSubmitting
                  }, null, 8, ["label", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}